/**
 * Make artwork URLs work in <img> tags. Dropbox "share" links use HTML preview by default;
 * `raw=1` forces a direct file response browsers can display.
 * Stored value stays whatever the user pasted; this is for display / preview only.
 */
export function artworkUrlForDisplay(url: string): string {
  const trimmed = (url || '').trim()
  if (!trimmed || trimmed === 'null' || trimmed === 'undefined') return ''

  try {
    const parsed = new URL(trimmed)
    const host = parsed.hostname.replace(/^www\./, '')
    if (host === 'dropbox.com' || host.endsWith('.dropbox.com')) {
      parsed.searchParams.delete('dl')
      parsed.searchParams.set('raw', '1')
      return parsed.toString()
    }
  } catch {
    return trimmed
  }
  return trimmed
}

/** Order matches catalog & forms: main art fields, then `artwork_link` (Dropbox / asset link). */
const CATALOG_ARTWORK_KEYS: readonly string[] = [
  'artwork',
  'album_artwork',
  'albumArtwork',
  'artwork_url',
  'artworkUrl',
  'image_url',
  'imageUrl',
  'cover_url',
  'coverUrl',
  'artwork_link',
]

function firstArtworkStringFromObject(obj: unknown): string {
  if (obj == null || typeof obj !== 'object') return ''
  const o = obj as Record<string, unknown>
  for (const k of CATALOG_ARTWORK_KEYS) {
    const v = o[k]
    if (typeof v === 'string') {
      const t = v.trim()
      if (t && t !== 'null' && t !== 'undefined') return t
    }
  }
  return ''
}

/**
 * One URL to show for catalog rows / dashboard (song object and/or `raw` API payload).
 * Prefer top-level `artwork`… then `artwork_link`, same as the Music list + Dizee “Artwork (Asset)” field.
 */
export function catalogArtworkDisplayUrl(song: object | null | undefined): string | null {
  if (!song) return null
  let s = firstArtworkStringFromObject(song)
  if (!s) {
    const raw = (song as { raw?: unknown }).raw
    if (raw != null) s = firstArtworkStringFromObject(raw)
  }
  if (!s) return null
  const d = artworkUrlForDisplay(s)
  return d || null
}
